<template>
    <div :id="ecahrtID"></div>
</template>
<script>
export default {
    props: {
        titleText: {
            type: String,
            default() {
                return '';
            }
        },
        XAxisData: {
            type: Array,
            default() {
                return [];
            }
        },
        seriseData: {
            type: Array,
            default() {
                return [];
            }
        },
        legendData: {
            type: Array,
            default() {
                return [];
            }
        },
        maxNumber: {
            type: Number,
            default() {
                return 0;
            }
        },
        ecahrtID: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            echartsList: {
                title: {
                    text: this.titleText,
                    left: 'center',
                    top: 20,
                    textStyle: {
                        color: '#595959',
                        fontSize: 16
                    }
                },
                backgroundColor: '#ffffff',
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                        shadowStyle: {
                            color: '#000000',
                            opacity: 0.1
                        }
                    }
                },
                legend: {
                    data: this.legendData,
                    bottom: '-4px'
                },
                grid: {
                    top: '15%',
                    right: '3%',
                    left: '6%',
                    bottom: '12%'
                },
                xAxis: [{
                    type: 'category',
                    data: this.XAxisData,
                    axisLine: {
                        lineStyle: {
                            color: '#D9D9D9',
                            type: 'solid'
                        }
                    },
                    axisLabel: {
                        margin: 10,
                        textStyle: {
                            fontSize: 14,
                            color: 'rgba(0,0,0,0.65)'
                        },
                        formatter: function(value) {
                            var ret = '';
                            var maxLength = 8;
                            var valLength = value.length;
                            var rowN = Math.ceil(valLength / maxLength);
                            if (rowN > 1) {
                                for (var i = 0; i < rowN; i++) {
                                    var temp = '';
                                    var start = i * maxLength;
                                    var end = start + maxLength;
                                    temp = value.substring(start, end) + '\n';
                                    ret += temp;
                                }
                                return ret;
                            } else {
                                return value;
                            }
                        }
                    }
                }],
                yAxis: [{
                    axisLabel: {
                        color: '#000000',
                        formatter: function (value) {
                            if (value >= 10000 && value < 10000000) {
                                value = (value / 10000).toString().substring(0, 6) + '万';
                            } else if (value >= 10000000 && value < 100000000) {
                                value = (value / 10000000).toString().substring(0, 6) + '千万';
                            } else if (value >= 100000000) {
                                value = (value / 100000000).toString().substring(0, 6) + '亿';
                            }
                            return value;
                        }
                    },
                    axisLine: {
                        show: false
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#E8E8E8',
                            type: 'dashed'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitNumber: 10,
                    min: 0,
                    max: 0,
                    interval: 0
                }],
                series: this.seriseData
            }
        };
    },
    methods: {
        drawEcharts() {
            const that = this;
            const ecahrtDOM = document.getElementById(this.ecahrtID);
            if (ecahrtDOM) {
                let myChart = that.$echarts.init(ecahrtDOM);
                myChart.dispose();
                myChart = that.$echarts.init(ecahrtDOM);
                // 绘制图表
                myChart.setOption(that.echartsList);
            }
        },
        setData() {
            this.echartsList.yAxis[0].max = (Math.floor(this.maxNumber / 10) + 1) * 10;
            this.echartsList.yAxis[0].interval = ((Math.floor(this.maxNumber / 10) + 1) * 10) / 10;
        }
    },
    mounted() {
        this.drawEcharts();
        window.addEventListener('resize', this.drawEcharts);
    },
    created() {
        this.setData();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.drawEcharts);
    },
    watch: {
        XAxisData(val) {
            if (val) {
                this.$set(this.echartsList.xAxis[0], 'data', val);
                this.drawEcharts(this.echartsList);
            }
        },
        titleText(val) {
            if (val) {
                this.$set(this.echartsList.title, 'text', val);
                this.drawEcharts(this.echartsList);
            }
        },
        seriseData(val) {
            if (val) {
                this.$set(this.echartsList, 'series', val);
                this.drawEcharts(this.echartsList);
            }
        },
        maxNumber(val) {
            if (val) {
                this.$set(this.echartsList.yAxis[0], 'max', (Math.floor(val / 10) + 1) * 10);
                this.$set(this.echartsList.yAxis[0], 'interval', ((Math.floor(val / 10) + 1) * 10) / 10);
                this.drawEcharts(this.echartsList);
            }
        }
    }
};
</script>
<style lang="less">
#reportEchart {
    height: 100%;
    width: 100%;
}
</style>